import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { UploadFile, Visibility } from '@app/components';
import { Button, FormContext, FormDatePicker, FormSubmitButton, MasterDetailForm, Row } from '@digital/ui';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { editandoState, modalAcoesIdState, vendorListDocsState } from '../atoms';
import * as Yup from 'yup';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, updateEnviarDPC } from '@app/api/sas/sasProposta';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { IArquivo } from '@app/types/core.types';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

interface Props {
    sasProposta: ISasPropostaOrdemCompra;
}

const ModalEnvioDPC = (props: Props) => {
    const { sasProposta } = props;

    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const editando = useRecoilValue(editandoState);
    const vendorListDocs = useRecoilValue(vendorListDocsState);

    const [exibirModal, setExibirModal] = useState(false);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    useEffect(() => {
        var doc = vendorListDocs.find(f => f.id == sasProposta.id);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }
    }, [exibirModal]);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleCancelAndClose = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);

        Modal.confirm({
            title: 'Confirmação',
            content: `Confirma envio para o DPC ?`,
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {
                if (editando.sasPropostaId == sasProposta.id) {
                    Modal.confirm({
                        title: <>{editando.justificativa}</>,
                        content: <ModalConfirmContentJustificativa
                            texto='É necessário informar a justificativa para a alteração.'
                            setJustificativa={e => {
                                form.set('justificativaEdicao', e);
                            }}
                        />,
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk: async (e) => {
                            form.append('editando', 'true');
                            return await new Promise((resolve, reject) => {
                                updateEnviarDPC(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            handleCancelAndClose();
                                            return resolve(true);
                                        } else {
                                            if (data.notifications && data.notifications.length > 0) {
                                                const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                                    return c.property == 'justificativaEdicao';
                                                });
                                                if (erroJustificativaEdicao >= 0) {
                                                    return reject(false);
                                                }
                                            }
                                        }
                                    });
                            });
                        },
                        onCancel: handleCancelAndClose
                    });
                }
                else {
                    updateEnviarDPC(form)
                        .then((data: any) => {
                            if (data && data.valid) {
                                handleCancelAndClose();
                            }
                        });

                }
            }
        });
    };

    return (
        <>
            <Tooltip title="Envio para o DPC">
                <Button icon='files-check_file_filled2' onClick={() => { setExibirModal(true); }} />
            </Tooltip>
            <Visibility visible={exibirModal}>

                <Modal
                    title={`Envio para o DPC`}
                    width='780px'
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <Visibility visible={exibirModal} >
                        <MasterDetailForm
                            key={`formEnvioDpc_${sasProposta.id}`}
                            validationSchema={Yup.object().shape({
                                dataDeEnvio: Yup.string().required("A data não pode ser vazia"),
                                arquivo: isObjNotEmpty(doc) && doc.anexoEnvioAoDpc ?
                                    Yup.mixed().notRequired() : Yup.mixed().required("É necessário anexar um arquivo")
                            })}
                            actions={[
                                <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                                <FormSubmitButton title='Enviar' type='primary' noIcon onClick={handleSubmit} />
                            ]}
                            initialValues={{
                                sasPropostaId: sasProposta.id,
                                dataDeEnvio: sasProposta.dataResultadoEnvioDpc,
                            }}
                        >
                            <FormContext.Consumer>
                                {({ formProps }) => (
                                    <>
                                        <Row style={{ paddingBottom: '16px' }}>
                                            <FormDatePicker
                                                format="DD/MM/YYYY"
                                                label="Data de Envio"
                                                name="dataDeEnvio"
                                                span={6}
                                                disabled={
                                                    sasProposta.resultadoEnvioDpc === 'Enviado' &&
                                                    editando.sasPropostaId !== sasProposta.id
                                                }
                                            />
                                        </Row>
                                        <Row>
                                            {
                                                (
                                                    sasProposta.resultadoEnvioDpc !== 'Enviado' ||
                                                    editando.sasPropostaId === sasProposta.id
                                                ) &&
                                                <UploadFile
                                                    idDoComponente='arquivoModalEnvioDPC'
                                                    type='primary'
                                                    hasLabel={true}
                                                    icon='ui-upload'
                                                    span={6}

                                                    onGetArquivo={() => {

                                                        if (isObjNotEmpty(doc.anexoEnvioAoDpc)) {
                                                            return Promise.resolve({
                                                                id: doc.anexoEnvioAoDpc.id,
                                                                nome: doc.anexoEnvioAoDpc.nome,
                                                                status: "",
                                                                statusArquivoId: doc.anexoEnvioAoDpc.statusArquivoId || "",
                                                            } as IArquivo);
                                                        }
                                                        return Promise.resolve(undefined);

                                                    }}
                                                    showDownload={true}
                                                />
                                            }
                                        </Row>
                                    </>
                                )}
                            </FormContext.Consumer>
                        </MasterDetailForm>
                    </Visibility>
                </Modal>

            </Visibility>
        </>
    );
};

export default ModalEnvioDPC;